var exports = {
  "user-name_color_purple": "x61f99309--19621e--user-name_color_purple",
  "user-name_color_dark": "x61f99309--19621e--user-name_color_dark",
  "user-name_color_plum": "x61f99309--19621e--user-name_color_plum",
  "name-replacement-image": "x61f99309--19621e--name-replacement-image",
};

module.exports = exports;
